// Blog hero + card imagery. Keyed by post slug.
//
// One asset per post, used both as the /resources/blog card thumbnail and
// as the post's own hero. Kept as a separate module so that BlogIndex and
// BlogPost read from the same source of truth without either page needing
// to reach into blog.js internals.
//
// Filenames follow the pattern /assets/blog-{slug}.{webp|jpg}. Single
// candidate only — no responsive srcset arms — because the SPA catch-all
// returns index.html at 200 for missing /assets URLs and browsers render
// that as a broken image.
const heroDims = { width: 1200, height: 630 };

export const BLOG_IMAGES = {
  "oman-pdpl-compliance-checklist-2026": {
    webp: "/assets/blog-oman-pdpl-compliance-checklist-2026.webp",
    jpg: "/assets/blog-oman-pdpl-compliance-checklist-2026.jpg",
    alt: "Flat illustration of a clipboard with five ticked green checkboxes and one unticked, and a pen resting on top.",
    ...heroDims,
  },
  "does-your-data-have-to-stay-in-oman": {
    webp: "/assets/blog-does-your-data-have-to-stay-in-oman.webp",
    jpg: "/assets/blog-does-your-data-have-to-stay-in-oman.jpg",
    alt: "Flat illustration of a green server rack sitting on the outline of Oman with a padlock beside it, suggesting data residency.",
    ...heroDims,
  },
  "what-software-costs-in-oman": {
    webp: "/assets/blog-what-software-costs-in-oman.webp",
    jpg: "/assets/blog-what-software-costs-in-oman.jpg",
    alt: "Flat illustration of a calculator next to a rising green bar chart with an arrow, representing software cost trends.",
    ...heroDims,
  },
  "how-to-choose-a-software-development-company-in-oman": {
    webp: "/assets/blog-how-to-choose-a-software-development-company-in-oman.webp",
    jpg: "/assets/blog-how-to-choose-a-software-development-company-in-oman.jpg",
    alt: "Flat illustration of a magnifying glass inspecting a cluster of city buildings with gears, representing evaluating a software company.",
    ...heroDims,
  },
  "building-a-risk-register-your-auditor-accepts": {
    webp: "/assets/blog-building-a-risk-register-your-auditor-accepts.webp",
    jpg: "/assets/blog-building-a-risk-register-your-auditor-accepts.jpg",
    alt: "Flat illustration of an open ledger showing two columns of ticked green rows, with an audit-shield symbol resting against the spine.",
    ...heroDims,
  },
};

export function getBlogImage(slug) {
  return BLOG_IMAGES[slug] || null;
}
